export default __webpack_public_path__ + "static/media/actions-want-to-watch.bedbd8b0.svg";